export default "__VITE_ASSET___tgTuBVO__"